export default __webpack_public_path__ + "static/media/message.a69074d4.svg";